// extracted by mini-css-extract-plugin
export default {"label":"_1eqxl","labelText":"_1cf9X","adCount":"_3E9Pj"};